import React, { useEffect } from 'react';

import AuthService from '../../shared/services/AuthService';
import { DashboardProps } from '../App';
import EmailIcon from '@mui/icons-material/Email';
import Grid from '@mui/material/Unstable_Grid2';
import PersonIcon from '@mui/icons-material/Person';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import UserAvatar from '../../membership/components/UserAvatar';
import { avatarStyles } from '../../shared/hooks/useAvatarStyles';
import useExternalUser from '../../membership/hooks/useExternalUser';
import { useMediaQuery } from '@mui/material';
import useSingletonUser from '../../shared/hooks/useSingletonUser';
import useUser from '../../membership/hooks/useUser';

const UserProfilePanel = () => {
  const { user } = useSingletonUser();
  const { userkey, firstname, lastname, email } = user;

  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );
  const spacing = isSmallScreen ? 2 : 3;
  const { showUsername } = useExternalUser(userkey, user);

  return (
    <Grid container spacing={spacing} wrap="nowrap" alignItems="center">
      <Grid>
        <UserAvatar userkey={userkey} sx={avatarStyles} />
      </Grid>
      <Grid>
        <Grid container wrap="nowrap" direction="column" spacing={1}>
          <Grid>
            <Typography
              variant={isSmallScreen ? 'h5' : 'h4'}
              className="dashboard-userdetails"
            >
              {`${firstname} ${lastname}`}
            </Typography>
          </Grid>
          {showUsername && (
            <Grid>
              <Grid container alignItems="center" spacing={1}>
                <Grid>
                  <PersonIcon fontSize="small" />
                </Grid>
                <Grid xs>
                  <Typography variant="body1" className="dashboard-userdetails">
                    {showUsername}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
          {email && (
            <Grid>
              <Grid container alignItems="center" spacing={1}>
                <Grid>
                  <EmailIcon fontSize="small" />
                </Grid>
                <Grid xs>
                  <Typography variant="body1" className="dashboard-userdetails">
                    {email}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default UserProfilePanel;
